import Sortable from 'sortablejs';

export default class SortableItems {

	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new SortableItems;
		self.attachEvents();
	}

	attachEvents() {
		const self = this;

		self.attachSortable();

		window.site.attachSortable = function() {
			self.attachSortable();
		};
	}

	attachSortable() {
		const self = this,
			el = document.getElementsByClassName("js-sortable-container");

		for (let item of el) {
			new Sortable(item, {
                swapThreshold: 1,
				animation: 150,
				handle: '.js-sortable-handle',
				onUpdate: function (evt) {
					let $images = $(item).find('> [data-id]'),
						ids = [];

					$images.each(function() {
						ids.push($(this).data('id'));
					});

					oc.progressBar.show();

					oc.ajax('sellBusiness::onUpdatePhotographDocumentOrder', {
				        data: {ids: ids},
				        success: function(data, textStatus, jqXHR) {
				            this.success(data, textStatus, jqXHR);

				            oc.progressBar.hide();
				        }
				    });

					oc.ajax('sellBusiness::onUpdateFloorplanDocumentOrder', {
				        data: {ids: ids},
				        success: function(data, textStatus, jqXHR) {
				            this.success(data, textStatus, jqXHR);

				            oc.progressBar.hide();
				        }
				    });
				}
            });
		}
	}
}
